import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { Form, FormSpy } from 'react-final-form'

import Select from 'components/_form/Select'
import { ResizeContext } from 'contexts/Resize'

import { FormBox } from './styles'

const DeliveryTypeForm = ({ isDisabled, options, onChange, defaultValues }) => {
  const { mobile, breakpoint } = useContext(ResizeContext)

  return (
    <FormBox>
      <Form
        onSubmit={() => {}}
        initialValues={defaultValues}
        render={() => (
          <form id="delivery-info">
            <Select
              isDisabled={isDisabled}
              skipError={true}
              isRounded={true}
              withUnderline={false}
              name="delivery"
              options={options}
              isMobile={mobile || breakpoint === ''}
            />
            <FormSpy
              subscribe={{ values: true }}
              onChange={({ values }) => onChange(values.delivery)}
            />
          </form>
        )}
      />
    </FormBox>
  )
}

DeliveryTypeForm.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default DeliveryTypeForm
